<div class="selection-change-title d-flex align-items-center justify-content-between">
  <span class="new-select-label" [innerHTML]="title"></span>
</div>
<form [formGroup]="form" class="row">
  <div class="col-12 col-sm-6" [class.mb-4]="!noMargin()">
    <ng-select
      formControlName="select"
      class="new-select"
      [items]="items"
      [placeholder]="selectConfig?.placeholder"
      [searchable]="false"
      [clearable]="false"
      [tabIndex]="-1"
      (change)="changeValue($event)"
    />
  </div>
  <ng-container *ngIf="useCurrencyMask; else plainInput">
    <currency-input
      class="col-12 col-sm-6"
      [class.mb-4]="!noMargin()"
      [errMessages]="errorMessages('input')"
      #input
      [disabled]="disabledInput"
      formControlName="input"
      [placeholder]="config.name"
      [displayPrefix]="currencyDisplayPrefix"
    />
  </ng-container>

  <ng-template #plainInput>
    <input-v2
      class="col-12 col-sm-6"
      [class.mb-4]="!noMargin()"
      [errMessages]="errorMessages('input')"
      #input
      [disabled]="disabledInput"
      formControlName="input"
      [placeholder]="config.name"
      [type]="config.type"
    />
  </ng-template>
</form>
